export const TOPIC_IDS = {
  APP_READY: 'App.ready',
  WINDOW_CHANGE_BREAKPOINT: 'WindowState.changeBreakpoint',
  DISABLE_SCROLL_DISABLE: 'DisableScroll.disable',
  DISABLE_SCROLL_RELEASE: 'DisableScroll.release',
} as const;

export const MEDIA_QUERIES = {
  MOBILE: '(max-width: 767px)',
  DESKTOP: '(min-width: 768px)',
  DESKTOP_SM: '(min-width: 768px) and (max-width: 959px)',
  DESKTOP_MD: '(min-width: 768px) and (max-width: 1280px)',
  DESKTOP_LARGE: '(min-width: 1366px)',
} as const;

export const BREAK_POINTS = {
  MOBILE: 767,
  DESKTOP: 768,
  DESKTOP_SM: 959,
  DESKTOP_MD: 1280,
  DESKTOP_LARGE: 1366,
};

export const COOKIES = {
  GDPR: '__asics_gdpr_agree',
} as const;

export const ENDPOINTS = {} as const;
